<div class="d-flex coverage">
  <div
    class="col-md-3"
    *ngFor="let coverageName of summaryPanel?.CoverageDetails?.CoverageItems"
  >
    <p>{{ coverageName.Name }}</p>
    <div class="row" *ngIf="summaryPanel?.CoverageDetails?.CoverageItems">
      <div
        *ngFor="
          let limits of (summaryPanel?.CoverageDetails?.CoverageItems)[0]
            ?.Limits
        "
      >
        <span>{{ limits.Name }} </span>
        <span class="sub-text">{{ limits.Amount }}</span>
      </div>
    </div>
  </div>

  <div
    class="col-md-3"
    *ngIf="
      (summaryPanel?.CoverageDetails?.CoverageItems)[0]
        .PollutionIncidentLiability
    "
  >
    <p>
      POLLUTION INCIDENT LIABILITY
    </p>
    <span
      *ngFor="
        let pollutionIncident of (summaryPanel?.CoverageDetails
          ?.CoverageItems)[0]?.PollutionIncidentLiability
      "
    >
      {{ pollutionIncident.Amount }}<br />
    </span>
  </div>

  <div
    class="col-md-6"
    *ngIf="
      (summaryPanel?.CoverageDetails?.CoverageItems)[0].AdditionalInformation
    "
  >
    <p>
      ADDITIONAL INFORMATION
    </p>

    <div
      *ngFor="
        let items of (summaryPanel?.CoverageDetails?.CoverageItems)[0]
          ?.AdditionalInformation
      "
    >
      <span>
        {{ items }}
      </span>
    </div>
  </div>
</div>
